import styled from 'styled-components';
import { rem } from 'polished';
import { OrderPanelStyled, PriceCss } from '../../OrderPanelStyled';

export const OrderPanelStyledOV = styled(OrderPanelStyled)`
    .wrapper {
        .section {
            border-color: ${({ theme }) => theme.colors.grey16} !important;
            border-width: 1px !important;

            .order-panel-price-container {
                ${PriceCss}

                .content {
                    .header {
                        font-size: ${({ theme }) => theme.fontSizes.h7};
                    }

                    .body {
                        .body-wrapper {
                            .price {
                                font-size: ${rem(16)};
                            }
                            .or {
                                line-height: ${rem('17px')};
                            }
                            .infoIcon {
                                position: relative;
                                top: ${rem('-4px')};
                            }
                        }
                    }
                }
            }
        }
    }

    .desktopContactSection {
        .modalLink {
            color: ${({ theme }) => theme.colors.black2};

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black2};
                    stroke: ${({ theme }) => theme.colors.black2};
                }
            }

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }

        .phoneLink {
            color: ${({ theme }) => theme.colors.black2};
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.black2};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};

        .label {
            svg {
                margin-left: ${rem(5)};
            }
        }

        .phone {
            svg {
                width: ${rem(30)};
                height: ${rem(15)};
                margin-right: ${rem(5)};
                margin-bottom: ${rem(4)};

                path {
                    fill: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }
`;
